import { Directive, effect, inject, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, RouterLink } from '@angular/router';
import { SettingsService } from '../settings/settings.service';
import { WebdokuService } from '../../web-doku/webdoku.service';

@Directive({
  selector: '[ldwShouldOpenInNewTab]',
  standalone: false
})
export class OpenInNewTabDirective {
  settingsService = inject(SettingsService);

  private readonly _routerLinkDirective = inject(RouterLink);
  private readonly _webDokuService = inject(WebdokuService)



  constructor() {
    effect(() => {
      if (this.settingsService.settings.documentMode.openDocInNewTab || this.settingsService.settings.documentMode.allowNewTabOnIconClick) {
        this._routerLinkDirective.target = '_blank';
        this._routerLinkDirective.queryParams = { selectedPlanningJob: this._webDokuService.selectedPlanningJob()?.name }
        // need to call onChanges, because RouterLink does not update when queryParams are set twice
        this._routerLinkDirective.ngOnChanges();
      }
    })

  }
}
